import {
  ArrowLeftIcon,
  CheckSquare2Icon,
  ClipboardListIcon,
  ContactIcon,
  CpuIcon,
  CreditCardIcon,
  FlaskConicalIcon,
  FlaskRoundIcon,
  LockIcon,
  PencilRulerIcon,
  PlugIcon,
  PrinterIcon,
  ScanEyeIcon,
  SlidersIcon,
  TestTubesIcon,
  UsersIcon,
  WorkflowIcon,
} from "lucide-react";

import { Link } from "@/components/Link";
import { LogoB } from "@/components/ui/logo";
import { Separator } from "@/components/ui/separator";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuLink,
} from "@/components/ui/sidebar";
import { Text } from "@/components/ui/text";

export function AdminSidebar() {
  return (
    <Sidebar>
      <SidebarHeader>
        <div className="px-3 flex items-center gap-1 shrink-0">
          <LogoB className="size-6" />
          <Separator orientation="vertical" className="mr-1" />
          <Text size="4">Admin</Text>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/tests">
                  <FlaskConicalIcon />
                  Test specs
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/panels">
                  <ClipboardListIcon />
                  Panels
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/results">
                  <CheckSquare2Icon />
                  Results
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/tubes">
                  <TestTubesIcon />
                  Containers
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/materials">
                  <FlaskRoundIcon />
                  Materials
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/instruments">
                  <CpuIcon />
                  Instruments
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/printers">
                  <PrinterIcon />
                  Printers
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/clients">
                  <ContactIcon />
                  Organizations
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/users">
                  <UsersIcon />
                  Users
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/billing">
                  <CreditCardIcon />
                  Billing
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/auth">
                  <LockIcon />
                  Authentication
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/audit">
                  <ScanEyeIcon />
                  Audit Logs
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/processes">
                  <PencilRulerIcon />
                  Processes
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/workflows">
                  <WorkflowIcon />
                  Rules
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/integrations">
                  <PlugIcon />
                  Integrations
                </SidebarMenuLink>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuLink to="/admin/settings">
                  <SlidersIcon />
                  Settings
                </SidebarMenuLink>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>
        <Link
          to="/accessions"
          asButton
          variant="ghost"
          className="bg-transparent hover:bg-foreground/5"
        >
          <ArrowLeftIcon /> Back to bLIS
        </Link>
      </SidebarFooter>
    </Sidebar>
  );
}
